import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-delegate-review',
    templateUrl: './delegate-review.component.html',
    styleUrls: ['./delegate-review.component.scss'],
    standalone: false
})
export class DelegateReviewComponent implements OnInit {
  @Input() myFormGroup: any;
  @Input() label: any;

  constructor() { }

  ngOnInit(): void {
    this.myFormGroup = this.myFormGroup.value;
    console.log('myFormGroup: ', this.myFormGroup);
  }

}
